import { useParams, useNavigate } from "react-router-dom";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";
import CustomInputSwitch from "@/components/desktop/form/input/input-switch/CustomInputSwitch";

import { useToleranceForm } from "@/hooks/maintainers/OA/Tolerances/useToleranceForm";
import classes from "./tolerance-form.module.scss";

const ToleranceForm = ({ filters }) => {
	const navigate = useNavigate();
	const { option, element_id } = useParams();

	const onClose = () => navigate("/configuracion/tolerancias");

	const { isOpen, modalTitle, isLoading, formState, setFormState, formErrors, handleSubmit } = useToleranceForm({
		option,
		filters,
		elementId: element_id,
		onClose,
	});

	if (!isOpen) return null;

	return (
		<CustomModalForm open={isOpen} onClose={onClose} title={modalTitle} size="lg" asForm onSubmit={handleSubmit} isLoading={isLoading}>
			{isLoading ? (
				<CustomFetching center size="lg" />
			) : (
				<>
					<div style={{ gridColumn: "span 12", display: "flex", justifyContent: "space-between" }}>
						<div>
							Tolerancia de Aplicación por Bodega <br />
							<span style={{ fontSize: 14 }}>
								Tolerancia <strong>{formState.is_active ? "activa" : "desactivada"}</strong>
							</span>
						</div>
						<CustomInputSwitch
							label="Activo"
							value={formState.is_active}
							onChange={(val) => setFormState((prev) => ({ ...prev, is_active: val }))}
							optionLeft="No"
							optionRight="Si"
						/>
					</div>

					<CustomInputNumber
						label="Margen Inferior"
						name="lower_margin"
						value={formState.lower_margin}
						onChange={(val) => setFormState((prev) => ({ ...prev, lower_margin: val }))}
						placeholder="Ej: 10"
						helper="Porcentaje de tolerancia por debajo del valor esperado"
						required
						col={6}
						disabled={!formState.is_active}
						error={formErrors.lower_margin}
						className={!formState.is_active ? classes.disabled : ""}
					/>

					<CustomInputNumber
						label="Margen Superior"
						name="upper_margin"
						value={formState.upper_margin}
						onChange={(val) => setFormState((prev) => ({ ...prev, upper_margin: val }))}
						placeholder="Ej: 10"
						helper="Porcentaje de tolerancia por encima del valor esperado"
						required
						disabled={!formState.is_active}
						col={6}
						className={!formState.is_active ? classes.disabled : ""}
						error={formErrors.upper_margin}
					/>
				</>
			)}
		</CustomModalForm>
	);
};

export default ToleranceForm;
